import { cn, Pill } from '@landler/component-library';

import { BenchmarkType } from '@/api/rest/resources/types/fact';
import { BenchmarkPill } from '@/components/Pill/BenchmarkPill';
import { isNullish } from '@/utils/booleans';
import { getStyleForBenchmark } from '@/utils/getStyleForBenchmark';
import { getStyleForLinkage } from '@/utils/getStyleForLinkage';

const getBenchmarkFromIndex = (index: number) => {
  if (index === 0) return BenchmarkType.unchanged;
  if (index < 0.2) return BenchmarkType.very_low;
  if (index < 0.4) return BenchmarkType.low;
  if (index < 0.6) return BenchmarkType.moderate;
  if (index < 0.8) return BenchmarkType.high;
  if (index <= 1.0) return BenchmarkType.very_high;
  return BenchmarkType.unchanged;
};

const getInverseBenchmarkFromIndex = (index: number) => {
  if (index === 0) return BenchmarkType.unchanged;
  if (index < 0.2) return BenchmarkType.very_high;
  if (index < 0.4) return BenchmarkType.high;
  if (index < 0.6) return BenchmarkType.moderate;
  if (index < 0.8) return BenchmarkType.low;
  if (index <= 1.0) return BenchmarkType.very_low;
  return BenchmarkType.unchanged;
};

export const LinkageCell = ({ value }: { value?: number }) => {
  if (isNullish(value)) return null;

  const benchmarkType = getBenchmarkFromIndex(value);

  if (isNullish(benchmarkType)) return null;

  const style = getStyleForLinkage(benchmarkType);

  if (benchmarkType === BenchmarkType.unchanged) return null;

  return (
    <BenchmarkPill
      benchmarkType={benchmarkType}
      className='w-full text-white-100 rounded-md px-4 py-3 typography-body1 self-center justify-center'
      style={{
        color: style?.text,
        backgroundColor: style?.primary,
      }}
    />
  );
};

export const ScoreCell = ({ value }: { value?: number }) => {
  if (isNullish(value)) return null;

  const benchmarkType = getBenchmarkFromIndex(value);
  if (isNullish(benchmarkType)) return null;

  const style = getStyleForBenchmark(benchmarkType);

  if (benchmarkType === BenchmarkType.unchanged) return null;
  return (
    <Pill
      className={cn(
        'typography-overline font-bold w-full text-white-100 rounded-md px-4 py-3 typography-body1 self-center justify-center',
      )}
      style={{
        color: style?.text,
        backgroundColor: style?.primary,
      }}
    >
      {value?.toFixed(2)}
    </Pill>
  );
};

export const RiskCell = ({ value }: { value?: number }) => {
  if (isNullish(value)) return null;

  const benchmarkType = getInverseBenchmarkFromIndex(value);
  if (isNullish(benchmarkType)) return null;

  const style = getStyleForBenchmark(benchmarkType);

  if (benchmarkType === BenchmarkType.unchanged) return null;

  return (
    <BenchmarkPill
      benchmarkType={benchmarkType}
      className='w-full text-white-100 rounded-md px-4 py-3 typography-body1 self-center justify-center'
      style={{
        color: style?.text,
        backgroundColor: style?.primary,
      }}
    />
  );
};
